import React, { Component } from 'react'
import { connect } from "react-redux";
import { getAnnualBillingSettings, saveAnnualBillingSettings } from '../../../../../store/actions';

class SettingsView extends Component {

  state = { reportSettings: {}, einCharge: 0, w2Charge: 0 };

  componentDidMount = async () => {
    await this.props.getAnnualBillingSettings();
    let { einCharge, w2Charge } = this.props.ANNUAL_BILLING_SETTINGS;
    this.setState({ reportSettings: this.props.ANNUAL_BILLING_SETTINGS, einCharge: einCharge || 0, w2Charge: w2Charge || 0 });
  };

  saveSettings = async (data, prop) => {
    return this.props.saveAnnualBillingSettings({ ...this.state.reportSettings, [prop]: data });
  };

  render() {

    let { einCharge, w2Charge } = this.state;
    return (
      <>
        <div className="shadow_white_box full-box mt-0">
          <label>EIN Charge</label>
          <div className="clients_grid">
            <input
              type="number"
              value={einCharge}
              onChange={(e) => this.setState({ einCharge: e.target.value })}
            ></input>
            <button onClick={async () => this.saveSettings(einCharge, 'einCharge')}>Save</button>
          </div>

        </div>

        <div className="shadow_white_box full-box mt-0">
          <label>W2 Charge</label>
          <div className="clients_grid">
            <input
              type="number"
              value={w2Charge}
              onChange={(e) => this.setState({ w2Charge: e.target.value })}
            ></input>
            <button onClick={async () => this.saveSettings(w2Charge, 'w2Charge')}>Save</button>
          </div>

        </div>
      </>
    )
  }
}


const mapStateToProps = ({ ReportSettingsReducer }) => {
  const { ANNUAL_BILLING_SETTINGS, } = ReportSettingsReducer;
  return { ANNUAL_BILLING_SETTINGS };
};
export default connect(mapStateToProps, { getAnnualBillingSettings, saveAnnualBillingSettings })(SettingsView);
